<script>
import {VclCode} from 'vue-content-loading';
import {OrbitSpinner} from 'epic-spinners'
import {get_acsrf_token, gameToGameIcon} from "@/methods";
import {required, minLength, maxLength} from "vuelidate/lib/validators";
import {Game} from "@/enums";

function parseISO8601String(dateString) {
	var timebits = /^([0-9]{4})-([0-9]{2})-([0-9]{2})T([0-9]{2}):([0-9]{2})(?::([0-9]*)(\.[0-9]*)?)?(?:([+-])([0-9]{2})([0-9]{2}))?/;
	var m = timebits.exec(dateString);
	var resultDate;
	if (m) {
		var utcdate = Date.UTC(parseInt(m[1]),
			parseInt(m[2]) - 1, // months are zero-offset (!)
			parseInt(m[3]),
			parseInt(m[4]), parseInt(m[5]), // hh:mm
			(m[6] && parseInt(m[6]) || 0),  // optional seconds
			(m[7] && parseFloat(m[7]) * 1000) || 0); // optional fraction
		// utcdate is milliseconds since the epoch
		if (m[9] && m[10]) {
			var offsetMinutes = parseInt(m[9]) * 60 + parseInt(m[10]);
			utcdate += (m[8] === '+' ? -1 : +1) * offsetMinutes * 60000;
		}
		resultDate = new Date(utcdate);
	} else {
		resultDate = null;
	}
	return resultDate;
}

export default {
	components: {
		// eslint-disable-next-line vue/no-unused-components
		VclCode,
		// eslint-disable-next-line vue/no-unused-components
		OrbitSpinner
	},
	validations: {
		applicationForm: {
			name: {required, minLength: minLength(3), maxLength: maxLength(24)}
		}
	},
	props: {},
	methods: {
		handleError: function (error) {
			console.log(`[ERROR] ${error}`);
			this.error = true;
		},
		async getData() {
			try {
				let response = await fetch(process.env.VUE_APP_ROOT_API + `v1/gamelabs/workshopitems`, {
					method: 'GET',
					credentials: 'include'
				});

				if (response.ok) {
					let data = await response.json();
					this.items = data.items;
					this.ready = true;
				} else {
					if (response.status === 429) {
						this.$toast.warning('You are being rate limited');

					} else
						throw new Error(`(${this.$vnode.componentOptions.tag}) Failed with API error ${response.status}=${response.statusText} (${response.url})`);
				}
			} catch (error) {
				console.log(`[ERROR] ${error}`);
				this.$swal({
					icon: 'error',
					text: 'Failed to contact Steam service'
				});
			}
		},
		async showApplicationWizard() {
			this.$refs.addApplicationModal.show();
		},
		async validateApplicationForm() {
			this.$v.applicationForm.$touch();
		},
		async createApplication() {
			this.$v.applicationForm.$touch();
			if (this.$v.applicationForm.$error) return;

			this.creationInProgress = true;
			await new Promise(resolve => setTimeout(resolve, 2000));
			try {
				let acsrf_token = await get_acsrf_token();
				let payload = {
					acsrf_token: acsrf_token,
					name: this.applicationForm.name
				};
				let response = await fetch(process.env.VUE_APP_ROOT_API + `v1/api/applications`, {
					method: 'POST',
					body: JSON.stringify(payload),
					credentials: 'include'
				});

				if (response.ok) {
					this.applicationForm = {
						name: null
					};
					this.$refs.addApplicationModal.hide();
					this.$swal({
						icon: 'success',
						text: 'Application deployed'
					});
					await this.getData();
				} else {
					if (response.status === 429) {
						this.$toast.warning('You have been rate limited');

					} else
						throw new Error(`(${this.$vnode.componentOptions.tag}) Failed with API error ${response.status}=${response.statusText} (${response.url})`);
				}
			} catch (error) {
				console.log(`[ERROR] ${error}`);
				this.$swal({
					icon: 'error',
					text: 'Could not create application'
				});
			}
			this.creationInProgress = false;
		}
	},
	created() {
		this.getData()
	},
	data() {
		return {
			ready: false,
			error: false,
			items: []
		}
	}
};
</script>

<template>
	<div>
		<div class="page-title-box d-flex align-items-center justify-content-between">
			<h2 class="mb-0">
				Steam Workshop Items
			</h2>
			<!--
		<div class="page-title-right bv-d-xs-down-none"><ol class="breadcrumb m-0">
			<button class="btn btn-primary btn-lg text-uppercase" :disabled="creationInProgress" v-on:click="showApplicationWizard()">
				<h5 class="mb-0">
					<orbit-spinner
							v-if="creationInProgress"
							:animation-duration="900"
							:size="18"
							class="align-middle d-inline-block"
					/>
					New application
				</h5>
			</button>
		</ol>
		</div>
		-->
		</div>
		<div class="mb-4">
			<h5 class="text-muted">
				Manage Steam Workshop items that are owned by the Steam account attached to your CFCloud account
			</h5>
		</div>
		<template v-if="ready">
			<template v-if="items.length === 0">
				<div class="row">
					<div class="col justify-content-center">
						<div class="info-component text-center align-middle mt-auto mb-auto">
							<div class="info-component-space">
								<i class="fad fa-empty-set info-component-icon"></i>
							</div>
							<div class="row" style="margin-top: 20px;">
								<div class="col-lg-12">
									<h3 v-b-tooltip.hover title="Wow such empty 👻">Nothing here yet</h3>
									<h5 class="text-muted">You can only manage Steam Workshop items that are owned by
										the Steam account attached to your CFCloud account</h5>
								</div>
							</div>
						</div>
					</div>
				</div>
			</template>
			<template v-else>
				<div class="row ml-lg-5 mr-lg-5">
					<div class="col-lg-3 col-sm-12 h-100" v-for="item in items" :key="item.file_id">
						<router-link :to="{name: 'workshop_item', params: {file_id: item.file_id}}">
							<div class="card text-white h-100">
								<div class="card-body h-100">
									<div class="pull-left position-absolute">
										<div class="badge badge-default text-black" v-if="item.game">
											<h6 class="mb-0">
												<img :src="'/' +gameIcon(item.game)" alt="server game logo" height="24">
											</h6>
										</div>
									</div>
									<div class="row justify-content-center">
										<div class="col text-center">
											<h3 class="pb-0 mt-5 mb-3 text-truncate">
												{{ item.page.title }}
												<h6 class="m-0 p-0 text-muted">
													Id: {{ item.file_id }}
												</h6>
											</h3>
										</div>
									</div>
								</div>
								<div class="card-footer">
									<div class="row text-center">
										<div class="col">
											<p class="text-muted text-truncate mb-2">
												Subscriptions
											</p>
											<h5 class="mb-0">
												{{ item.stats.current.subscriptions }}
											</h5>
										</div>
										<div class="col">
											<p class="text-muted text-truncate mb-2">
												Rating
											</p>
											<h5 class="mb-0">
												{{ (item.stats.voting.score * 100).toFixed(2) }} %
												<span class="small text-muted">
														{{ item.stats.voting.up }} <i class="fad fa-arrow-up font-size-11"/>
														{{ item.stats.voting.down }} <i class="fad fa-arrow-down font-size-11"/>
												</span>
											</h5>
										</div>
									</div>
								</div>
							</div>
						</router-link>
					</div>
				</div>
			</template>
		</template>
		<template v-else-if="error">
			<div class="row">
				<div class="col-lg-12 col-sm-12 row justify-content-center">
					<div class="col-lg-6 col-sm-12">
						<div class="card border border-danger">
							<div class="card-header bg-transparent border-danger">
								<h5 class="my-0 text-danger">
									<i class="far fa-exclamation-circle mr-3"></i>
									We have encountered an error
								</h5>
							</div>
							<div class="card-body pt-0">
								<h5 class="card-title mt-0">Please try again later</h5>
							</div>
						</div>
					</div>
				</div>
			</div>
		</template>
		<template v-else>
			<div class="row">
				<div class="col-lg-3 col-sm-12" v-for="index in 5" :key="index">
					<div class="card">
						<div class="card-body">
							<vcl-code :width="300" :speed="1" primary="#FFFFFF" secondary="#bdbdbd"></vcl-code>
						</div>
					</div>
				</div>
			</div>
		</template>
	</div>

</template>
